import React, { useEffect } from "react";

import AssessmentReviewPage from "@Components/assessment/AssessmentReviewPage";
import { SELECTION_TABS } from "@Components/assessment/types";
import { ErrorBoundary } from "@Components/shared/ErrorBoundary";
import { useSearchParams } from "@Utils";

import AdminContainer from "@Components/assessment/AdminContainer";
import "@Styles/pages/assessmentReviewPage.scss";
import { checkCap } from "@Components/assessment/helpers";
import { AssessmentsError } from "@Components/assessment//AssessmentsError";

const AssessmentsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const assessmentParam = searchParams.get("assessment");
  const isAdminView = SELECTION_TABS.map<string>((st) => st).includes(tabParam);

  const canCreate = checkCap("Assessment/Create");

  useEffect(() => {
    if (!!tabParam || !!assessmentParam) return;

    setSearchParams({ tab: canCreate ? "current" : "assigned" }, { replace: true });
  }, [assessmentParam, canCreate, setSearchParams, tabParam]);

  return (
    <ErrorBoundary FallbackComponent={AssessmentsError}>
      {isAdminView ? (
        <>
          <AdminContainer />
        </>
      ) : (
        <AssessmentReviewPage />
      )}
    </ErrorBoundary>
  );
};

export default AssessmentsPage;
